import { render, staticRenderFns } from "./AjaxVueSelect.vue?vue&type=template&id=5f83be62&scoped=true&"
import script from "./AjaxVueSelect.vue?vue&type=script&lang=js&"
export * from "./AjaxVueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83be62",
  null
  
)

export default component.exports